import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { MysqlService } from './../../services/mysql.service';
import { FileUploaderService } from './../../services/file-uploader-service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { environment } from './../../../environments/environment';




@Component({
  selector: 'app-file-uploads-modal',
  templateUrl: './file-uploads-modal.component.html',
  styleUrls: ['./file-uploads-modal.component.css']
})
export class FileUploadsModalComponent implements OnInit {

     @Input() brand_id: number;
    @Input() title: string = 'Upload or Select File';
// as a model vars
    @Input() item_id: number;
    @Input()  closeBtnName: string;
    @Input() list: any[] = [];
    @Input() user_id: number;


  loading: boolean;
  // set an event emitter to send back to parent component
  @Output() action = new EventEmitter();
  @Output('addFileNameFromModal') addFileNameFromModal: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

  sessionBrandId: any;
  sessionUsername: any;
  sessionUserId: any;
  currentUserVAR: any;
  
  div: any;
  public nav: any;
  public body: any;
  public container: any;
  // Uploader Service Vars
  // public title = 'File Upload Manager - Brands';
  // public imgUploaded: string;
  public tableData: any;
  public baseUploadURL =  environment.baseUploadURL_BrandAssets; // no trailing slash // added brand_id to HTML 
  sent_brand_id: any;






  constructor(
    private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
    private modelService: BsModalService
  ) { 
// login vars
this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
console.log('sessionUserId: ', this.currentUserVAR.user_id );
console.log('sessionUsername: ', this.currentUserVAR.username );
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id; 

// get the values from the context vars from model sent into the html into .ts
//let context:any = DialogRef.context;
//this.sent_brand_id = context?.brand_id;

// this.sent_brand_id = this.bsModalRef?.content?.brand_id;



  }

ngOnChanges(): void {
  //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
  //Add '${implements OnChanges}' to the class.
  this.sent_brand_id = this.brand_id;
  
}

  ngOnInit() {

// this.refreshList();
   // this.sent_brand_id = this.brand_id;
         // refresh the upload list
         
         // when model opens
         // this.list.push('I added one here.');
  }





// Uploader Functions
public uploadBrandImage(brand_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadBrandImage(formData, brand_id).subscribe(res=> this.dataLoaded(res));


}


// Uploader Functions
public uploadImage(): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadImage(formData).subscribe(res=> this.dataLoaded(res));
}


dataLoaded(data: any): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='hidden';
 // this.imgUploaded = data._body;
this.refreshList();
}

refreshList(): void {
this.fileUploader.getBrandsList(this.brand_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
// this.tableData = data.json();
this.tableData = data;
}

// end uploader functions


loadList(brand_id): void {
  this.fileUploader.getBrandsList(brand_id).subscribe(res=> this.displayTableData(res));
  
  }



public clickOk(filename) {
  // tslint:disable-next-line:indent
  console.log('Clicked...');
  this.loading = true;
  // this.action.emit(true); /// << here you can send object  instead of true
  console.log('Clicked...' , filename);
  // this.action.emit(filename); /// << here you can send object  instead of true
  

 this.addFileNameFromModal.emit('asdfasdfasdfsadfsd');


//  this.closeParentModelDefault.emit();
}


public clickFile(filename) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(filename); /// << here you can send object  instead of true
  this.bsModalRef.hide();
}







} // end
